<template>

  <el-tooltip v-if="item.suitable" placement="top-start" :enterable="item.title === ''" :hide-after="hideMil"
              :value="item.title===''" :open-delay="openDelay">
    <div slot="content" v-if="item.suitable==='all'"> 适用系统：云停车场，vems</div>
    <div slot="content" v-else-if="item.suitable==='vems'"> 适用系统：vems传统停车场</div>
    <div slot="content" v-else-if="item.suitable==='cloud'"> 适用系统：云停车场</div>
    <div slot="content" v-else-if="item.suitable==='third'"> 适用系统：第三方停车场</div>
    <div slot="content" v-else-if="item.suitable==='guide'"> 适用系统：引导系统</div>
    <el-menu-item @click="callMethod(item)" :key="item.linkUrl" :index="item.linkUrl">
      {{item.title}}
    </el-menu-item>
  </el-tooltip>
  <el-menu-item v-else @click="callMethod(item)" :key="item.linkUrl" :index="item.linkUrl">
    {{item.title}}
  </el-menu-item>
</template>

<script>
  export default {
    props: ["item", "openDelay"],
    name: "MenuItem",
    data() {
      return {
        hideMil: 1000
      }
    },
    methods: {
      callMethod(item) {
        this.$emit("childMethod", item);
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MenuItem.vue